import React, { useEffect, useState, useContext } from "react";
import Media from "react-media";
import Comment from "../Assets/img/Blogs/comment.png";
import Fb_icon from "../Assets/img/Blogs/fb_icon.png";
import Insta_icon from "../Assets/img/Blogs/insta_icon.png";
import like_blog from "../Assets/img/Blogs/like_blog.png";
import liked_blog from "../Assets/img/Blogs/liked_blog.png";
import Save_icon from "../Assets/img/Blogs/save_icon.png";
import Link_icon from "../Assets/img/Blogs/link_icon.png";
import Blog_img1 from "../Assets/img/Blogs/blog_img1.png";
import Blogs from "../Assets/img/Blogs/blogs.png";
import ReactQuill from "react-quill";
import Footer from "../components/Footer";
import SendIcon from "../Assets/img/Blogs/send_icon.png";
// import "react-quill/dist/quill.bubble.css";
import "../components/Blogs/quill.bubble.css";
import { AuthContext } from "../Context/AuthContext";
import moment from "moment";
import { Button } from "react-bootstrap";
import Navbar from "../components/Navbar";
import { store } from "react-notifications-component";
import ContentLoader from "react-content-loader";
import { BASE_URL } from "../env";
function removeHTMLTags(str) {
	return str.replace(/<[^>]*>?/gm, "");
}

function BlogPage(props) {
	const blogImgBig = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
	};
	function notifyPopup(message, title, type) {
		store.addNotification({
			title: title,
			message: message,
			type: type,
			background: "pink",
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	const qlEditor = {
		boxSizing: "border-box",
		lineHeight: "1.42",
		height: "100%",
		outline: "none",
		overflowY: "auto",
		padding: " 12px 15px",
		tabSize: "4",
		// -moz-tab-size: "4",
		textAlign: "left",
		whiteSpace: "pre-wrap",
		wordWrap: "break-word",
	};

	// if (props.location.state) {
	//   var data = props.location.state.data;
	// }
	const [blog, setBlog] = useState([]);
	const [date, setDate] = useState(null);
	const [comment, setComment] = useState([]);

	const [msg, showMsg] = useState(" ");
	const [input1, setInput] = useState("");
	const [commentStatus, commentSet] = useState("");
	const { token, update_token, set_Id } = useContext(AuthContext);
	const [liked, setLiked] = useState(false);
	const [user_id, setUser_Id] = useState("");
	const [likes, setLikes] = useState([]);
	const [loaded, setLoaded] = useState(false);
	// let date = "";

	useEffect(() => {
		let token = localStorage.getItem("token");
		fetch(BASE_URL + "/getProfile", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				authorization: token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setUser_Id(data?.user?._id);
			});
	}, []);

	useEffect(() => {
		const blogID = props.match.params.id;
		fetch(BASE_URL + "/blog/" + blogID)
			.then((response) => response.json())
			.then((data) => {
				console.log("data Blog", data.blog);
				setComment(data.blog.comments);
				setLikes(data.blog.likes);
				setBlog(data.blog);

				data.blog.likes.map((item) => {
					if (item == user_id) {
						setLiked(true);
					} else {
						setLiked(false);
					}
				});
				setLoaded(true);
			})
			.catch((err) => {
				console.log(err);
			});
		const today = moment();
		let blogDate = moment(blog.date).format();
		// console.log("today", today);
		// console.log("blog", blogDate);
		setDate(today.diff(blogDate, "days"));
		console.log("diff1", date);
		console.log("diff", today.diff(blogDate, "days"));
	}, [props, input1, likes]);

	async function handleComment(e) {
		e.preventDefault();
		const token1 = localStorage.getItem("token");
		if (token1 === null) {
			commentSet("Please Login To comment on the Article! ");
		} else if (input1 === "") {
			commentSet("Please Type something to post! ");
		} else {
			const blogID = props.match.params.id;
			console.log(blogID);
			console.log("this is input", input1);

			console.log(token);
			const url4 = BASE_URL + `/commentBlog/${blogID}`;
			const wait = await fetch(url4, {
				method: "POST",
				headers: {
					authorization: localStorage.getItem("token"),
					"Content-Type": "application/json",
					"Access-Control-Allow-Origin": "*",
				},
				body: JSON.stringify({
					comment: input1,
				}),
			})
				.then((response) => response.json())
				.catch((err) => {
					setInput(" ");
					commentSet("sorry couldn't post the comment1");
				});
			console.log("wait", wait.message.slice(0, 15));

			if (wait.message.slice(0, 15) === "Comment posted!") {
				setInput(" ");
				return commentSet("sucessfully posted the comment!!");
			} else {
				setInput(" ");
				commentSet("sorry couldn't post the comment");
			}
		}
	}

	async function handleLikes() {
		if (liked) {
			return;
		} else {
			const token1 = localStorage.getItem("token");
			if (token1 === null) {
				notifyPopup(
					"Please Login To comment on the Article! ",
					"Please Login!",
					"warning"
				);
			} else {
				const blogID = props.match.params.id;
				console.log(blogID);

				console.log(token);
				const url4 = BASE_URL + `/like/${blogID}`;
				fetch(url4, {
					method: "put",
					headers: {
						authorization: localStorage.getItem("token"),
						"Content-Type": "application/json",
						"Access-Control-Allow-Origin": "*",
					},
				})
					.then((response) => response.json())
					.then(() => {
						setLiked(true);
					})
					.catch((err) => {
						notifyPopup("Some Error Occured!", "Error", "danger");
						console.log("Error in Likes", err);
					});
			}
		}
	}

	return (
		<>
			<Navbar />
			{loaded ? (
				<div
					style={{ marginTop: "7%", overflow: "hidden" }}
					className="container"
				>
					<div className="row">
						<div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 blogpage-div-1">
							<h5 className="web-dev-heading">
								Product Companies
							</h5>
							<hr className="web-hr" />
							<h2 className="work-from-home">{blog.title}</h2>
							<div className="d-flex blog-read">
								<div>
									<h6
										onClick={() => {
											console.log(date);
										}}
										className="tendays"
									>
										{date == 0 || date == null
											? moment(blog.date).format(
													"MMMM Do YYYY"
											  )
											: `${date} Day ago.`}
										{/* {date} Day ago. */}
										{/* {moment(data.date).format("dddd, MMMM Do YYYY, h:mm a")} */}
									</h6>
								</div>
								<div>
									<a href="https://www.facebook.com/Cantilever-labs-102916474752041/">
										<img
											src={Fb_icon}
											alt=""
											className="img-fluid blog-il-img"
										/>
									</a>
									<a href="https://www.linkedin.com/company/cantileverlabs/">
										<img
											src={Link_icon}
											alt=""
											className="img-fluid blog-il-img"
										/>
									</a>
									<a href="https://www.instagram.com/cantilever_labs/?hl=en">
										<img
											src={Insta_icon}
											alt=""
											className="img-fluid blog-il-img"
										/>
									</a>
									<img
										src={Save_icon}
										alt=""
										className="img-fluid blog-il-img"
									/>
								</div>
							</div>
							<br />
							<img
								// src="https://cantilever-blog-images.s3.ap-south-1.amazonaws.com/Product%20Hiring%20Company.jpeg"
								src={blog.image}
								alt=""
								className="img-fluid"
								style={blogImgBig}
							/>
							<div className="photo-credits">
								<h6>photo credits</h6>
							</div>
							<br />
							<h4 className="blog-para">
								{/* <span className="w">W</span>hat is Lorem Ipsum? */}
							</h4>
							<div className="noselect">
								<ReactQuill
									style={qlEditor}
									// style={{ fontSize: "10px" }}
									value={blog.body || ""}
									readOnly={true}
									theme={"bubble"}
								/>
							</div>

							<br />

							<div className="d-flex blog-read">
								<div>
									{liked ? (
										<img
											src={liked_blog}
											style={{ width: "30px" }}
											alt="like post"
											className=" img-fluid"
										/>
									) : (
										<img
											src={like_blog}
											style={{
												color: "red",
												cursor: "pointer",
												width: "30px",
											}}
											alt="like post"
											className=" img-fluid"
											onClick={() => {
												handleLikes();
											}}
										/>
									)}
									{likes.length}
									<img
										src={Comment}
										alt=""
										className="comment img-fluid"
									/>
									{comment.length}
								</div>
								<div>
									<img
										src={Fb_icon}
										alt=""
										className="img-fluid blog-il-img"
									/>
									<img
										src={Link_icon}
										alt=""
										className="img-fluid blog-il-img"
									/>
									<img
										src={Insta_icon}
										alt=""
										className="img-fluid blog-il-img"
									/>
									<img
										src={Save_icon}
										alt=""
										className="img-fluid blog-il-img"
									/>
								</div>
							</div>

							<hr className="hr-blog" />
						</div>
					</div>
					<div>
						<div
							className="row justify-content-center"
							style={{
								overflow: "hidden",
							}}
						>
							<div
								className="col-xl-10 col-lg-10 col-md-12 col-sm-12 blogpage-form-div1 my-4 "
								style={{
									borderRadius: "15px",
									borderStyle: "solid",
									borderWidth: "2px",
									alignItems: "center",
									borderColor: "#707070",
								}}
							>
								<div
									style={{
										height: "200px",
										overflow: "auto",
										scrollbarWidth: "none",
									}}
									className="my-3 mx-2"
								>
									{comment.map((item) => {
										return (
											<div
												key={item._id}
												className="blogpage-form-div2"
											>
												<p
													style={{
														color: "black",
														fontSize: "1rem",
														fontWeight: "600",
													}}
												>
													{item.review}
												</p>
												<p>
													<span>
														{item.date.slice(0, 10)}
													</span>
													&nbsp;&nbsp;
													{item.userName}
												</p>
											</div>
										);
									})}
								</div>
								<div
									className="mt-2"
									style={{
										position: "sticky",
										marginBottom: "20px",
									}}
								>
									<form onSubmit={handleComment}>
										<div>
											<input
												type="text"
												className="blogpage-form-input p-1"
												placeholder="Type something"
												onChange={(e) =>
													setInput(e.target.value)
												}
												name="comment"
												value={input1}
												style={{
													width: "95%",
													fontWeight: "bold",
													color: "black",
													borderStyle: "solid",
													borderWidth: "2px",
													borderColor: "#707070",
												}}
											/>
											<button
												type="submit"
												style={{
													marginLeft: "-5%",
													borderStyle: "none",
													backgroundColor: "white",
													opacity:
														input1 === "" ? 0.2 : 1,
												}}
											>
												<img
													src={SendIcon}
													alt=""
													className="img-fluid blog-il-img"
												/>
											</button>
										</div>

										<p>{commentStatus}</p>
									</form>
								</div>
							</div>
						</div>
					</div>

					<div className="related-post-J my-2 mx-lg-5 mx-xl-5 mx-md-2 p-2">
						<h3>Related Posts</h3>
						<hr />
					</div>

					<div className="container-fluid">
						<Media query="(max-width: 750px)">
							{(matches) => {
								return matches ? (
									<div className="row">
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														Effects of New Vaccine
														Trails
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														2nd Wave and Its strains
														n Mutents
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														Impacts of Covid on
														Labours (May Day Spl)
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														Effects of New Vaccine
														Trails
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														2nd Wave and Its strains
														n Mutents
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text-mobile">
												<p>
													<span
														style={{
															fontSize: "10px",
															fontWeight: "900",
														}}
													>
														Impacts of Covid on
														Labours (May Day Spl)
													</span>
													<br />
													<span
														style={{
															fontSize: "8px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
									</div>
								) : (
									<div className="row">
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														Effects of New Vaccine
														Trails
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														2nd Wave and Its strains
														n Mutents
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														Impacts of Covid on
														Labours (May Day Spl)
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														Effects of New Vaccine
														Trails
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														2nd Wave and Its strains
														n Mutents
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
											<img
												src={Blogs}
												className="img-fluid blogs-img"
											/>
											<div className="blogs-text">
												<p>
													<span
														style={{
															fontSize: "12px",
															fontWeight: "900",
														}}
													>
														Impacts of Covid on
														Labours (May Day Spl)
													</span>
													<br />
													<span
														style={{
															fontSize: "10px",
														}}
													>
														10 Days ago . 5min Read
													</span>
												</p>
											</div>
										</div>
									</div>
								);
							}}
						</Media>
					</div>
				</div>
			) : (
				<>
					<ContentLoader
						speed={1}
						width={1360}
						height={900}
						viewBox="0 0 1360 900"
						backgroundColor="#f2f2f4"
						foregroundColor="#c0c0c0"
					>
						<rect
							x="30"
							y="20"
							rx="8"
							ry="8"
							width="200"
							height="200"
						/>
						<rect
							x="30"
							y="250"
							rx="0"
							ry="0"
							width="200"
							height="18"
						/>
						<rect
							x="30"
							y="275"
							rx="0"
							ry="0"
							width="120"
							height="20"
						/>
						<rect
							x="250"
							y="20"
							rx="8"
							ry="8"
							width="200"
							height="200"
						/>
						<rect
							x="250"
							y="250"
							rx="0"
							ry="0"
							width="200"
							height="18"
						/>
						<rect
							x="250"
							y="275"
							rx="0"
							ry="0"
							width="120"
							height="20"
						/>
						<rect
							x="470"
							y="20"
							rx="8"
							ry="8"
							width="200"
							height="200"
						/>
						<rect
							x="470"
							y="250"
							rx="0"
							ry="0"
							width="200"
							height="18"
						/>
						<rect
							x="470"
							y="275"
							rx="0"
							ry="0"
							width="120"
							height="20"
						/>
						<rect
							x="690"
							y="20"
							rx="8"
							ry="8"
							width="200"
							height="200"
						/>
						<rect
							x="690"
							y="250"
							rx="0"
							ry="0"
							width="200"
							height="18"
						/>
						<rect
							x="690"
							y="275"
							rx="0"
							ry="0"
							width="120"
							height="20"
						/>
						<rect
							x="910"
							y="20"
							rx="8"
							ry="8"
							width="200"
							height="200"
						/>
					</ContentLoader>
					<span className="sr-only">Loading...</span>
				</>
			)}

			<Footer />
		</>
	);
}
export default BlogPage;
